import { Button, Dialog } from "@mui/material";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useAuthorize } from "../../../hooks/use-authorize";
import { UserPermissionName } from "../../../models/user-permission-name";

interface LotUpdateDialog {
    isOpen: boolean;
    actionData: any;
    onClosed: (actionData: string) => void;
    onSubmit: (actionData: string) => void;
}
export const LotUpdateDialog = ({ isOpen, actionData, onSubmit, onClosed }: LotUpdateDialog) => {

    const handleSubmitDialog = () => {
        onSubmit(actionData);
    }
    const handleClosed = () => {
        onClosed(actionData);
    }

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={isOpen}
            className="modalpopup"
            title={'CONFIRM STATUS'}
        // onClose={closeDialog}
        >
            <div>
                <div style={{ padding: '25px 50px', textAlign: 'center' }}>
                    <div>{`If you change the value of "${actionData?.type}" in Project, this will change  the value of "${actionData?.type}" in Lots/Units also. Do you want to continue?`}</div>
                    {/* <LoadingIndicator isLoading={isLoadingUnitComplete} /> */}
                </div>
            </div>
            <DialogActionsBar>
                {isReadOnlyPermission && (
                    <Button style={{ maxWidth: '140px' }} size='small' type="button" variant="outlined" onClick={handleClosed}>
                        Cancel
                    </Button>
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }} className="  ">
                    <button
                        className="btn btn-sm btn-primary btn-lightGrey"
                        style={{
                            backgroundColor: (isReadOnlyPermission) ? '#d7dbdd' : '#0000b5',
                            color: (isReadOnlyPermission) ? 'black' : '#fff',
                            cursor: 'pointer', padding: 2, marginRight: 6
                        }}
                        disabled={isReadOnlyPermission}
                        onClick={handleClosed}
                        autoFocus
                    >
                        No
                    </button>

                    <button
                        className="btn btn-sm btn-primary  btn-delete"
                        style={{
                            backgroundColor: (isReadOnlyPermission) ? '#d7dbdd' : '#0000b5',
                            color: (isReadOnlyPermission) ? 'black' : '#fff',
                            cursor: 'pointer', padding: 2
                        }}
                        type="button"
                        onClick={handleSubmitDialog}
                        disabled={isReadOnlyPermission}
                    >
                        Yes
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    );
}